/** Offline fallback only; the reachable server's ordered mode list wins. */
export const FALLBACK_MODES = ["instant", "low", "medium", "high", "max", "deep_research"] as const;
/** Mode names are server-owned and may be added without a web release. */
export type Mode = string;
